<template>
  <el-dialog title="填写启动会时间"
             :visible.sync="dialogVisible"
             width="60%"
             top="20px"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <el-form label-width="120px">
      <el-form-item label="无需启动会">
        <el-switch v-model="form.no_kickoff_meeting">
        </el-switch>
        <span class="form-item-tip">常规项目可不需要填写启动会时间，开启后将跳过时间填写</span>
      </el-form-item>
      <el-form-item :label="`第${nextSeqNo}次启动会`"
                    prop="newMeetingTime"
                    v-if="!form.no_kickoff_meeting">
        <el-date-picker v-model="newMeetingTime"
                        class="width-max"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm"
                        placeholder="请选择启动会的时间"
                        :default-time="defaultTime"
                        clearable>
        </el-date-picker>
      </el-form-item>

      <el-form-item label="本次参会人"
                    prop="attendees"
                    v-show="!form.no_kickoff_meeting">
        <WecomDepartmentTree ref="attendeeTree"
                             v-if="dialogVisible"
                             :show-checkbox="true"
                             :default-expand-all="false"
                             :show-filter="true"
                             @check="onAttendeeCheck"/>
        <div v-if="selectedAttendees.length"
             class="attendee-tags">
          <el-tag v-for="a in selectedAttendees"
                  :key="a.key"
                  type="info"
                  size="mini"
                  closable
                  @close="removeAttendee(a)">{{ a.name }}
          </el-tag>
        </div>
        <span class="form-item-tip">勾选部门代表该部门下全部账号参会；也可仅勾选具体参会人</span>
      </el-form-item>

    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary"
                 @click="onSubmit">提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'
import WecomDepartmentTree from '@views/wecom/components/department-tree.vue'

export default {
  mixins: [userWorkInfoMixin, projectMixins],
  components: {WecomDepartmentTree},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      form: {
        no_kickoff_meeting: false,
      },
      submittedMeetingList: [],
      newMeetingTime: null,
      defaultTime: '00:00:00',
      checkedTick: 0,
    }
  },
  created () {},
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
    nextSeqNo () {
      const list = this.submittedMeetingList
      return list.length > 0 ? list[list.length - 1].seq_no + 1 : 1
    },
    selectedAttendees () {
      // 依赖 checkedTick 触发重算（$refs 非响应式）
      void this.checkedTick
      const treeRef = this.$refs.attendeeTree
      if (!treeRef) return []
      return (treeRef.getCheckedNodes() || []).filter(n => n.type === 'user')
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
    'form.no_kickoff_meeting' (val) {
      // 开启“无需启动会”时清空已选参会人，并取消树的勾选
      if (val) {
        const treeRef = this.$refs.attendeeTree
        if (treeRef) treeRef.setCheckedKeys([])
        this.checkedTick++
      }
    },
  },
  methods: {
    initAttr (projectNode) {
      this.form.no_kickoff_meeting = _.get(projectNode, 'node_result.no_kickoff_meeting', false)
      const version = _.get(projectNode, 'node_result.version', null)
      if (version === 2) {
        const oldMeeting = _.get(projectNode, 'node_result.kickoff_meeting', null)
        this.submittedMeetingList = oldMeeting ? [{ ...oldMeeting }] : []
      } else {
        this.submittedMeetingList = _.get(projectNode, 'node_result.kickoff_meeting_list', []).map(item => ({...item}))
      }
      this.newMeetingTime = null
      this.checkedTick++

      const now = new Date()
      const hh = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      this.defaultTime = `${hh}:${mm}:00`
    },
    async onSubmit () {
      // 需要启动会,必须配置日期
      if (!this.form.no_kickoff_meeting) {
        if (!this.newMeetingTime) {
          this.$message.error('第' + this.nextSeqNo + '次启动会时间不得留空')
          return
        }
        if (this.selectedAttendees.length === 0) {
          this.$message.error('请选择本次参会人')
          return
        }
      }

      const params = {
        id: this.projectId,
        no_kickoff_meeting: this.form.no_kickoff_meeting,
        kickoff_meeting: {
          seq_no: this.nextSeqNo,
          kickoff_meeting_time: this.newMeetingTime ? this.newMeetingTime + ':00' : null,
          attendees: this.selectedAttendees.map(a => ({ // 参会人
            type: a.type,
            key: a.key,
            userid: a.userid || '',
            name: a.name,
          })),
        }
      }
      await this.withLoading(async () => {
        try {
          const res = await request.common('addKickoffMeetingTimeApi', params)

          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('启动会时间保存成功')
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        }
      })
    },
    // 树勾选变化：触发 selectedAttendees 重算（数据以树的勾选状态为准）
    onAttendeeCheck () {
      this.checkedTick++
    },
    // 支持从列表直接移除已选参会人
    removeAttendee (attendee) {
      const treeRef = this.$refs.attendeeTree
      if (!treeRef) return
      const elTree = treeRef.getTreeRef()
      if (elTree) elTree.setChecked(attendee.key, false)
      this.checkedTick++
    },
  },
}
</script>

<style lang="scss"
       scoped>
.form-item-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.attendee-tags {
  margin-top: 4px;
  max-height: 96px;
  overflow-y: auto;
  line-height: 0;

  .el-tag {
    height: 20px;
    line-height: 18px;
    padding: 0 5px;
    margin: 0 4px 2px 0;

    .el-icon-close {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/KickoffMeetingDialog.vue